(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('otp-code', {
                parent: 'site',
                data: {
                    authorities: []
                },
                templateUrl: 'app/components/otp/otp-code.html',
                controller: 'OTPCodeController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            })
            .state('contact-us', {
                parent: 'site',
                cache:false,
                data: {
                    authorities: []
                },
                templateUrl: 'app/components/otp/contact.html',
                controller: 'ContactUsController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
